import { components as c } from "@/components";
import { useInjectionDiaryDefaultsQuery } from "@/features/injection/api/selectInjectionDiaryDefaults";
import InjectionFormFields from "@/features/injection/components/InjectionFormFields";
import type { InjectionSchemaZ } from "@/features/injection/types/injectionSchema";
import { useAuth } from "@/utils/auth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import { z } from "zod";

type InjectionFormSchemaT = z.infer<typeof InjectionSchemaZ>;

const InjectionPage = () => {
    const navigate = useNavigate();
    const { admin, trackers } = Route.useSearch();
    const auth = useAuth();
    const { data: defaultDiary } = useInjectionDiaryDefaultsQuery(auth.id);

    const form = useForm<InjectionFormSchemaT>({
        defaultValues: {
            referring_clinician_id: defaultDiary?.referring_clinician_id ?? "",
            injecting_clinician_id: defaultDiary?.injecting_clinician_id ?? "",
            injection_method_id: defaultDiary?.injection_method_id ?? "",
        },
    });

    const onSubmit = (data: InjectionFormSchemaT) => {
        navigate({
            to: "/templates/diary/intervention/injection/details",
            search: {
                admin,
                trackers,
                injection: JSON.stringify(data),
            },
        });
    };

    return (
        <>
            <c.cc.Title words="Injection Details" />
            <c.cc.Stepper
                steps={[
                    { stage: "past", words: "Admin" },
                    { stage: "past", words: "Trackers" },
                    { stage: "current", words: "Intervention" },
                    { stage: "future", words: "Details" },
                ]}
            />

            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <InjectionFormFields organisationId={JSON.parse(admin).organisation_id} control={form.control} />

                <div className="flex justify-end">
                    <c.fc.NextButton buttonType="submit" label="Next: Details" className="w-auto" />
                </div>
            </form>
        </>
    );
};

const InjectionSearchSchemaZ = z.object({
    admin: z.string(),
    trackers: z.string(),
});

export const Route = createFileRoute("/_app/templates/diary/_form/intervention/injection")({
    component: InjectionPage,
    validateSearch: (search) => InjectionSearchSchemaZ.parse(search),
});
